import { CLEAR_EXPORT_DATA } from 'constants/action-types/export/clearExportData';

export default () => dispatch => {
  dispatch({
    type: CLEAR_EXPORT_DATA,
  });
};
